import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, retry, throwError } from 'rxjs';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ResponseService } from 'src/app/types/type';
import { environment } from 'src/environments/environment';

enum methods {
  GetTipoRevisionesConfiguracion = 'GetTipoRevisionesConfiguracion',
  SetTipoRevision = 'SetTipoRevision',
}

@Injectable({
  providedIn: 'root'
})
export class TipoRevisionesService {
  headers: HttpHeaders;
  URL: string;

  constructor(private http: HttpClient) {
    this.URL = environment.urlService;
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  getTipoRevisionesConfiguracion(idEmpleado: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetTipoRevisionesConfiguracion}?=${idEmpleado}`)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  setTipoRevision(nuevaRevision: string, idEmpleado: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.SetTipoRevision}`, {
      t: {
        Descripcion: nuevaRevision
      },
      idEmpleado
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
